<template>
  <div class="u-relative u-marg-t-lg--sm">
    <div class="u-row u-row--sm">
      <div class="u-marg-l-2of12 u-pad-x-sm u-marg-l-0--sm u-pad-x-0--sm u-full-width">
        <img class="u-full-width" :src="$device.isMobile ? '/images/theme-4.jpg' : '/images/illu-1.jpg'">
      </div>
    </div>
    <div class="u-wrapper-panel u-row u-row--sm u-middle">
      <div class="u-marg-l-1of12 u-w6of12 u-w10of12--sm u-center--sm">
        <h1 class="t-h1">
          Prisme7 - {{ $t('video.title') }}
        </h1>
        <div class="u-marg-t-md">
          <cta @click="gotoVideoPlayer">
            <div class="u-flex u-middle">
              {{ $t('video.cta') }} 
              <svg class="t-icon t-fill-black u-marg-l-sm">
                <use xlink:href="#arrow-right"/>
              </svg>
            </div>
          </cta>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cta from '@/components/common/Cta'
import Easing from '@/utils/Easing'

export default {
  components: {
    Cta
  },
  created () {
    this.easing = null
  },
  methods : {
    gotoVideoPlayer () {
      let videoPlayer = document.querySelector('#videoplayer')
      let top = this.$offset.absolute(videoPlayer).top

      this.easing = new Easing({
        type: 'easeInOutQuad',
        duration: 1000,
        start: this.$device.scroll.top,
        end: top - ( ( this.$device.height - videoPlayer.offsetHeight ) * .5 ),
        callback: ()=>{
          this.$hub.emit('playVideo')
          this.easing = null
        }
      })

      this.easing.isActive = true
    },

    onUpdate (time) {
      if( this.easing !== null ) {
        window.scrollTo( 0, this.easing.update(time) )
      }
    }
  }
}
</script>